/* eslint-disable react/jsx-props-no-spreading */
import { hot } from 'react-hot-loader/root'

import '@piconetworks/avatar/dist/index.css'
import '@piconetworks/text/dist/index.css'
import '@piconetworks/boutton/dist/index.css'

import React from 'react'
import PropTypes from 'prop-types'

import {
    Router,
    Switch,
    Route,
} from 'react-router-dom'
import { connect } from 'react-redux'

import { history } from '@piconetworks/router-adapter'

import Header from 'apps/containers/Header'

import HeaderBar from 'apps/containers/Header/HeaderBar'

const Routes = ({
    accessToken,
    refreshToken,
}) => (
    <Router history={history}>
        <Switch>
            <Route
                exact
                path="/"
                render={(props) => <Header {...props} accessToken={accessToken} />}
            />

            <Route path="/header-bar" render={(props) => <HeaderBar {...props} accessToken={accessToken} refreshToken={refreshToken} />} />
        </Switch>
    </Router>
)

const mapStateToProps = ({
    _network: {
        access_token: {
            default: accessToken,
        },
        refresh_token: {
            default: refreshToken,
        },
    },
    loader: {
        user: {
            token,
        } = {},
    } = {},
}) => ({
    accessToken: accessToken || token,
    refreshToken,
})

Routes.defaultProps = {
    accessToken: null,
    refreshToken: null,
}

Routes.propTypes = {
    accessToken: PropTypes.string,
    refreshToken: PropTypes.string,
}

export default hot(connect(mapStateToProps)(Routes))
